export const VARIABLE_CONTENT_NODE_NAME = 'variable_content';
export const CONTENT_VARIANT_NODE_NAME = 'content_variant';

export const VARIABLE_CONTENT_DIRECTIVE_NAME = 'variants';
export const VARIANT_DIRECTIVE_NAME = 'variant';

/**
 * ProseMirror group for blocks allowed only under `doc`, not inside `content_variant`
 * (or other `block+` containers). Paired with doc content `(block | topLevelBlock)+`.
 */
export const TOP_LEVEL_BLOCK_GROUP = 'topLevelBlock';

/** UI / dimensions sentinel for the default (no match keys) variant. */
export const DEFAULT_VARIANT_VALUE = 'default';

export const EMPTY_DIMENSIONS_JSON = '{}';
